export const currencyCodes = ['EUR', 'USD', 'GBP', 'CLP']
